'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'

// lib
import { validateEmail, validateEmailErrorMessage } from '../validators'
import TextField, { TextFieldProps } from './text-field'

/* -----------------------------------------------------------------------------
 * EmailField
 * -------------------------------------------------------------------------- */

export type EmailFieldProps = Omit<TextFieldProps, 'label'> & {
  label?: TextFieldProps['label']
}

const EmailField = ({ required, ...props }: EmailFieldProps) => {
  const requiredVal =
    required && typeof required === 'boolean'
      ? validateEmailErrorMessage
      : required

  return (
    <TextField
      label='Email'
      validate={validateEmail()}
      required={requiredVal}
      keyboardType='email-address'
      textContentType='emailAddress'
      autoCompleteType='username'
      autoCapitalize='none'
      {...props}
    />
  )
}

export default EmailField
